import { SCREEN_SIZE } from "@app/_helpers/screen-size.enum";
import { UserToken } from "@app/_models";
import { AuthenticationService } from "@app/_services";
import { ResizeService } from "@app/_services/resize.service";

export abstract class BaseComponent {
  protected CurrentUser: UserToken = null;
  protected ScreenSize: SCREEN_SIZE;

  abstract onScreenResize(screenSize: SCREEN_SIZE);
  abstract onUserAvailable(userToken: UserToken);

  constructor(
    protected authenticationService: AuthenticationService,
    protected resizeService: ResizeService
  ) {
    this.authenticationService.currentUserToken.subscribe((userToken) => {
      this.CurrentUser = userToken;
      if (userToken != null) {
        this.onUserAvailable(userToken);
      }
    });

    this.resizeService.onResize$.subscribe((x) => {
      this.ScreenSize = x;
      this.onScreenResize(x);
    });
  }
}
